'use strict';
/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    valentineInit();
});

function valentineInit() {
    var $slider = $('.tiles-container');

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobile'),
            enter: function () {
                $slider.slick('unslick');

                if ($slider.children().length > 2) {
                    $slider.slick({
                        slidesToShow: 2,
                        dots: false,
                        arrows: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('tablet'),
            enter: function () {
                $slider.slick('unslick');

                if ($slider.children().length > 3) {
                    $slider.slick({
                        slidesToShow: 3,
                        dots: false,
                        arrows: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                $slider.slick('unslick');
 
                if ($slider.children().length > 4) {
                    $slider.slick({
                        slidesToShow: 4,
                        dots: false,
                        arrows: true
                    });
                }
            }
        }
    ]);
}
